<app-standard-table
  class="flex-1 flex flex-col min-h-0"
  [title]="'admin.confirmed-order'"
  [columns]="columnList"
  [data]="tableDataFilters"
  [totalItems]="totalItems"
  [pageSize]="pageSize"
  [isLoading]="isLoading"
  [currentPage]="currentPage"
  [isCreate]="false"
  [isImport]="false"
  [isExport]="true"
  [showStatusFilter]="false"
  [showDateFilter]="true"
  [showAlphabetFilter]="true"
  [alphabetOptions]="['A-', 'B-', 'C-']"
  (pageSizeChange)="onPageSizeChange($event)"
  (export)="exportExcel()"
  (searchChange)="search($event)"
  (pageChange)="onPageChange($event)"
  (dateFilterChange)="onDateFilterChange($event)"
  (alphabetFilterChange)="onAlphabetFilterChange($event)">
</app-standard-table>
